/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="54.6"
        viewBox="0 0 95.58 54.6"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M44.19 42.03a6.8 6.8 0 1 1-2.16 9.38 6.8 6.8 0 0 1 2.16-9.37"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m53.66 45.39 20.64-24.1-24.1 20.63 3.46 3.47z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M73.98 20.91 49.88 41.5a.51.51 0 0 0 0 .73l3.46 3.46a.48.48 0 0 0 .69 0l20.64-24.1a.502.502 0 1 0-.73-.69Zm-4.25 5L53.64 44.65l-2.7-2.7Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M47.79 0a47.79 47.79 0 0 1 47.79 47.79 1.26 1.26 0 0 1-1.08 1.25H83.13a1.25 1.25 0 0 1-1.23-1.27 1.27 1.27 0 0 1 1.1-1.22h10.07v-.27A45.31 45.31 0 0 0 48.5 2.48h-.75A45.3 45.3 0 0 0 2.5 46.28v.2h10a1.25 1.25 0 0 1 1.24 1.12v.13a1.26 1.26 0 0 1-1.12 1.25H1.25A1.25 1.25 0 0 1 0 47.73 47.79 47.79 0 0 1 47.79 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M13.98 14.01a1.24 1.24 0 0 1 1.66-.09l.1.09 7.93 7.92a1.26 1.26 0 0 1 .06 1.77 1.23 1.23 0 0 1-1.73.09l-.1-.09-7.92-7.92a1.24 1.24 0 0 1 0-1.76ZM47.79 0a1.27 1.27 0 0 1 1.25 1.12V12.5a1.27 1.27 0 0 1-1.28 1.23 1.24 1.24 0 0 1-1.21-1.1V1.28A1.25 1.25 0 0 1 47.79 0Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DialGaugeIcon';

export default Icon;
